import PropTypes from 'prop-types';
import React from 'react';

const LoadScreen = function LoadScreen(props) {
    if (props.show) {
        return (
            <div className="loadscreen-overlay">
                <div className="load-icon" />
            </div>
        );
    }
    return (<div />);
};

LoadScreen.propTypes = {
    show: PropTypes.bool
};

export default LoadScreen;
